import IndicadorCalor from "./IndicadorCalor";

const COLORES_BG = {
  verde: "#d4edda",
  amarillo: "#fff3cd",
  rojo: "#f8d7da",
};

const formatDias = (dias) => {
  if (dias === Infinity) return "—";
  if (dias === 0) return "Hoy";
  if (dias === 1) return "1d";
  return `${dias}d`;
};

const CardCliente = ({ cli }) => (
  <div
    style={{
      backgroundColor: COLORES_BG[cli.color],
      borderRadius: 10,
      padding: "12px 14px",
      width: 200,
      height: 90,
      border: "1px solid #ddd",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      overflow: "hidden",
    }}
  >
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 4 }}>
      <strong style={{ fontSize: ".82rem", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        {cli.empresa}
      </strong>
      <IndicadorCalor color={cli.color} size={12} />
    </div>
    <div className="text-muted" style={{ fontSize: ".73rem", lineHeight: 1.4 }}>
      <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        Ag: {cli.contactosAgencia.length > 0 ? cli.contactosAgencia[0].nombre : "—"}{" "}
        <span className="fw-medium">{formatDias(cli.diasAgencia)}</span>
      </div>
      <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        Cli: {cli.contactosCliente.length > 0 ? cli.contactosCliente[0].nombre : "—"}{" "}
        <span className="fw-medium">{formatDias(cli.diasCliente)}</span>
      </div>
    </div>
  </div>
);

const COLOR_PRIORITY = { rojo: 3, amarillo: 2, verde: 1 };

const CardsCalor = ({ data }) => {
  if (data.length === 0) {
    return <p className="text-muted text-center mt-4">No hay datos para mostrar</p>;
  }

  return (
    <div>
      {data.map((cat) => {
        const clientesOrdenados = [...cat.clientes].sort((a, b) => {
          const diff = (COLOR_PRIORITY[b.color] || 0) - (COLOR_PRIORITY[a.color] || 0);
          if (diff !== 0) return diff;
          return (a.empresa || "").localeCompare(b.empresa || "");
        });

        return (
          <div key={cat.id} style={{ marginBottom: 20 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
              <IndicadorCalor color={cat.color} size={14} />
              <strong style={{ fontSize: ".9rem" }}>{cat.nombre}</strong>
              <span className="text-muted small">({cat.clientes.length})</span>
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, 200px)",
                gap: 10,
              }}
            >
              {clientesOrdenados.map((cli) => (
                <CardCliente key={cli.id} cli={cli} />
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CardsCalor;
